module.exports = __webpack_public_path__ + "static/img/shopbanner.bf38b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/shopbanner.png
// module id = B22t
// module chunks = 5